import React, { useState } from 'react';

const CreateRoleModal = ({ existingRoles, onClose, onCreate }) => {
  const [code, setCode] = useState('');
  const [label, setLabel] = useState('');
  const [description, setDescription] = useState('');
  const [baseRole, setBaseRole] = useState('viewer');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const submit = async () => {
    try {
      setSubmitting(true);
      await onCreate({ code, label, description, base_role: baseRole });
    } catch (e) {
      setError(e?.response?.data?.error || e.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-card rounded-xl p-4 w-full max-w-md">
        <h3 className="text-sm font-semibold text-foreground mb-4">Create custom role</h3>
        {error && <div className="mb-3 p-2 bg-red-50 text-red-700 text-sm rounded">{error}</div>}
        <div className="space-y-3">
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">Code</label>
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, '_'))}
              className="w-full text-sm border border-input rounded-lg px-3 py-2 font-mono"
              placeholder="qa_lead"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">Label</label>
            <input
              type="text"
              value={label}
              onChange={(e) => setLabel(e.target.value)}
              className="w-full text-sm border border-input rounded-lg px-3 py-2"
              placeholder="QA Lead"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">Description (optional)</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full text-sm border border-input rounded-lg px-3 py-2"
              rows={2}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">Seed permissions from</label>
            <select
              value={baseRole}
              onChange={(e) => setBaseRole(e.target.value)}
              className="w-full text-sm border border-input rounded-lg px-3 py-2"
            >
              {existingRoles.map((r) => (
                <option key={r.code} value={r.code}>{r.label}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="flex justify-end gap-2 mt-5">
          <button
            onClick={onClose}
            className="text-sm font-medium text-muted-foreground border border-border rounded-lg px-4 py-2 hover:bg-muted/50"
          >
            Cancel
          </button>
          <button
            onClick={submit}
            disabled={submitting || !code || !label}
            className="text-sm font-medium text-white bg-primary rounded-lg px-4 py-2 hover:bg-primary/90 disabled:opacity-50"
          >
            {submitting ? 'Creating...' : 'Create role'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateRoleModal;
